import { Card, date } from '@enkla-gui'
import React, { useEffect, useRef, useState } from 'react'

import DatePicker from 'react-datepicker'

export default function Filter(props) {
	var [filter, setFilter] = useState(props.active ? props.active : {})
	const timer = useRef(null)

	useEffect(() => {
		props.useFilter(filter)
	}, [filter])

	const clear = key => {
		var copy = filter
		delete copy[key]
		setFilter({ ...copy })
	}
	if (props.hasOwnProperty('show') && !props.show) return ''
	const fields = () => {
		return (
			<div class='row filter-fields'>
				{props.filters.map(_filter => {
					const id = `filter-${_filter.key}`
					switch (_filter.type) {
						case 'toggle':
							{
								const selected = filter[_filter.key] || ''
								return (
									<div class='form-group filter-field col' key={_filter.key}>
										<label id={`${id}-label`}>{_filter.label}</label>
										<div class='filter-toggle-group' role='group' aria-labelledby={`${id}-label`}>
											{_filter.values.map(opt => (
												<button
													type='button'
													class={`filter-toggle ${selected === String(opt.value) ? 'active' : ''}`}
													aria-pressed={selected === String(opt.value)}
													onClick={() => selected === String(opt.value) ? clear(_filter.key) : setFilter({ ...filter, [_filter.key]: opt.value })}>
													{opt.icon && <i class={`fas ${opt.icon} me-1`} aria-hidden="true" />}{opt.label}
												</button>
											))}
										</div>
									</div>
								)
							}
						case 'select':
							return (
								<div class={`form-group filter-field col${props.filters.length > 3 ? '-4' : ''}`} key={_filter.key}>
									<label htmlFor={id}>{_filter.label}</label>
									{_filter.key in filter && (
										<button type='button' onClick={() => clear(_filter.key)} class='select-clear' aria-label={`Rensa ${_filter.label}`}>
											<i class='fas fa-times' aria-hidden="true" />
										</button>
									)}
									<select id={id} type='select' class='form-select' onChange={e => setFilter({ ...filter, [_filter.key]: e.target.value })}>
										<option disabled selected={!(_filter.key in filter)} value=''>
											Välj...
										</option>
										{_filter.values.map(value => (
											<option key={value.value} value={value.value}>{value.label}</option>
										))}
									</select>
								</div>
							)
						case 'input':
							return (
								<div class={`form-group filter-field col${props.filters.length > 3 ? '-4' : ''}`} key={_filter.key}>
									<label htmlFor={id}>{_filter.label}</label>
									<input
										id={id}
										onChange={e => {
											clearTimeout(timer.current)
											timer.current = setTimeout(() => {
												if (e.target.value === '') return clear(_filter.key)
												setFilter({ ...filter, [_filter.key]: e.target.value })
											}, 500)
										}}
										type={_filter.input_type || 'text'}
										class='form-control'
									/>
								</div>
							)
						case 'daterange':
							return (
								<div class={`form-group filter-field col${props.filters.length > 3 ? '-4' : ''}`} key={_filter.key}>
									<label htmlFor={id}>{_filter.label}</label>
									<DatePicker
										id={id}
										selectsRange={true}
										startDate={
											filter.hasOwnProperty(_filter.key) && JSON.parse(filter[_filter.key]).start !== null
												? new Date(JSON.parse(filter[_filter.key]).start)
												: ''
										}
										endDate={
											filter.hasOwnProperty(_filter.key) && JSON.parse(filter[_filter.key]).stop !== null ? new Date(JSON.parse(filter[_filter.key]).stop) : ''
										}
										className='form-control'
										locale='sv'
										dateFormat='yyyy-MM-dd'
										onChange={update => {
											if (update[0] === null && update[1] === null) return clear(_filter.key)
											setFilter({
												...filter,
												[_filter.key]: JSON.stringify({
													start: date.fixTimezone(update[0]),
													stop: date.fixTimezone(update[1])
												})
											})
										}}
										isClearable={true}
									/>
								</div>
							)
						default:
							return null
					}
				})}
			</div>
		)
	}
	return (
		<div class='component_Filter'>
			{
				!props.cardDeclined ?
					<Card title='Filtrera' icon='fas fa-filter'>
						{fields()}
					</Card>
					: (
						<div class="mb-4">
							{fields()}
						</div>
					)
			}
		</div>
	)
}
